import React from "react";
import styled from "styled-components";
import ViewAppBar from "../views/ViewAppBar";
import ViewInteresses from "../views/ViewInteresses";

import ViewFooter from "../views/ViewFooter";
import ContatoZap from "../components/ContatoZap";

const ContainerComponente = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 20px;

  @media (min-width: 200px) and (max-width: 399px) {
    padding: 8px;
    gap: 10px;
  }

  @media (min-width: 400px) and (max-width: 799px) {
    flex-wrap: wrap;
    gap: 15px;
  }

  @media (min-width: 800px) {
    justify-content: space-between;
    align-items: flex-start;
    gap: 30px;
  }
`;

const Interesses: React.FC = () => (
  <ContainerComponente>
    <ViewAppBar />
    <ViewInteresses />
    <ViewFooter />
  </ContainerComponente>
);
export default Interesses;
